module.exports = __webpack_public_path__ + "assets/images/project/next.svg?v=79be4e02";